import React, { useEffect, useMemo, useState } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Skeleton,
  Checkbox,
  CircularProgress,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Accessibility, AddBox, DirectionsRun } from "@mui/icons-material";
import InputField from "../formElements/InputField";
import { API, graphqlOperation } from "aws-amplify";
import { deleteCompanyCodeTranslation } from "../../graphql/mutations";
import { LoadingButton } from "@mui/lab";

import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../snackBar/snakbar";
import { useRef } from "react";
import { ThreeDot } from "../DropDown/ThreeDot";
import { Modal } from "./Modal";
import {
  getCompanyCodeTranslationApi,
  useCreateCompanyCodeTranslationArrayMutation,
  useGetCompanyCodeTranslationQuery,
} from "../../redux/apis/getCompanyCodeTranslation.api";
import { useDispatch } from "react-redux";
import useSaveShortcut from "../../hooks/useSaveShortcut";
import useSaveModalShortcut from "../../pages/PrimeFigma/Components/useSaveModalShortcut";
const style = {
  // position: 'absolute',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  // bgcolor: 'background.paper',
  // boxShadow: 24,
  // // p: 4,
  // outline: "none",
  // minWidth: '450px',
  // display: "flex",
  // flexDirection: "column",
  // maxHeight: "90vh"
  // overflow:'scroll'
};

const AddUnitsModal = ({
  from,
  open,
  setOpen,
  setNewUnit,
  uqcArray,
  listData,
  setData,
  currentUnit
}) => {
  const [tableLoading, settableLoading] = useState(false);
  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  const [Units, setUnits] = useState([]);
  const [DeleteArray, setDeleteArray] = useState([]);
  const [newUnits, setnewUnits] = useState([]);
  const [Selected, setSelected] = useState([]);
  const {
    data: unitList,
    isLoading: isUnitListLoading,
    isError: isUnitListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({ codetype: "UNITS" });

  let unitArray = useMemo(() => {
    if (!unitList) return [];
    return unitList;
  }, [unitList]);
  let dispatch = useDispatch();
  const loadUserUnits = async () => {
    try {
      dispatch(
        getCompanyCodeTranslationApi.util.invalidateTags([
          { type: "CodeTranslation", id: "UNITS" },
        ])
      );
      // let res = await API.graphql(
      //   graphqlOperation(getCompanyCodeTranslation, { CodeType: "units" })
      // );
      // if (res?.data?.getCompanyCodeTranslation?.length) {
      //   setUnits(res.data.getCompanyCodeTranslation);
      // }
      // settableLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // if (open) loadUserUnits();
    return () => {};
  }, [open]);

  const [loading, setLoading] = useState(false);
  const [
    createUnit,
    {
      isLoading: isCreatingUnit,
      isError: isCreateUnitError,
      isSuccess: isCreateUnitSuccess,
      error: createUnitError,
    },
  ] = useCreateCompanyCodeTranslationArrayMutation();
  async function createNewUnit(data) {
    try {
      // const res = await API.graphql(
      //   graphqlOperation(createCompanyCodeTranslation, {
      //     createCompanyCodeTranslationInput: data,
      //   })
      // );

      data.expiredtimestamp = 0;
      const res = await createUnit({
        createCompanyCodeTranslationArrayInput: [data],
      });
      console.log("res",res);
      
      if (res.data?.[0]?.statuscode == "Success") {
        // console.log(data);

        setNewUnit({
          option: data.codetext,
          value: from == "newItems" ? `${res?.data?.id}` : `${data?.codevalue}`,
        });
        newUnits?.map((item, index) => {
          if (index + 1 == newUnits.length) {
            showSuccessSnackbar(
              `Unit${newUnits.length != 1 ? "s" : ""} Created Successfully`
            );
            setnewUnits([]);
          }
        });
        // if (listData !== undefined) listData();

        // setState({
        //     unit: '',
        //     uqc: '',
        //     errorStatus: {
        //         unit: false,
        //         uqc: false,
        //     },
        //     errorFields: {
        //         unit: '',
        //         uqc: '',
        //     }
        // })
        setOpen(false);
      }else{
        showErrorSnackbar(res?.error?.message);
        setLoading(false)
      }

      // if(res.data.createCodeTranslation!==null) {
      //     setsuccessSnakbar(true)
      //     setSnakbarTex('Unit Created')
      //     setState({
      //         unit:'',
      //         uqc:'',
      //         errorStatus : {
      //             unit:false,
      //             uqc:false,
      //         },
      //         errorFields : {
      //             unit:'',
      //             uqc:'',
      //         }
      //     })
      //     setOpen(false)
      //     setLoading(false)
      // }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
      setLoading(false);
      const rawMessage = error.errors[0].message.split("RDSHttp:")[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
      showWarningSnackbar(errorMessage);
    }
  }

  function addunit(state) {
    const { unit, uqc } = state;
    // console.log(state);
    const formData = {
      unit,
      uqc,
    };
    if (formValidation(formData, state)) {
      let randomNumber = Math.floor(Math.random() * 100 + 1);
      let timeStamp = Math.floor(new Date().getTime() / 1000);
      const randomID = randomNumber + timeStamp.toString().slice(3, 10);

      const unitData = {
        codeorder: randomID,
        codetext: unit,
        codetype: "UNITS",
        codevalue: timeStamp,
        // EnteredTimeStamp: Math.floor(new Date().getTime()/ 1000),
        id: 0,
        // ExpiredTimeStamp: Math.floor(new Date().getTime()/ 1000),
        language: uqc,
        uqc: uqc,
        is_active: 1,
      };
      createNewUnit(unitData);
    }
  }

  function formValidation(data, state) {
    let isvalid = true;
    let obj = { ...state };
    let missingFields = [];
  
    Object.keys(data).forEach((itemKey) => {
      if (itemKey === "unit") {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          missingFields.push("Unit");
          // obj.errorFields.unit = "Unit is required";
          obj.errorStatus.unit = true;
        } else {
          obj.errorFields.unit = "";
          obj.errorStatus.unit = false;
        }
      }
  
      if (itemKey === "uqc") {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          missingFields.push("UQC");
          // obj.errorFields.uqc = "UQC is required";
          obj.errorStatus.uqc = true;
        } else {
          obj.errorFields.uqc = "";
          obj.errorStatus.uqc = false;
        }
      }
    });
  
    // Show combined message only if any field is missing
    if (missingFields.length > 0) {
      showWarningSnackbar(`${missingFields.join(", ")} is required`);
    }
  
    return isvalid;
  }
  

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      // setState((prev) => ({
      //     ...prev,
      //     unit: '',
      //     uqc: '',
      //     errorStatus: {
      //         unit: false,
      //         uqc: false,
      //     },
      //     errorFields: {
      //         unit: '',
      //         uqc: '',
      //     }
      // }))
      setDeleteArray([]);
      setnewUnits([]);
    }

    // setOpen(false);
  };

  const deleteUnit = async (data, index) => {
    Math.floor(new Date().getTime() / 1000);
    const exp = Math.floor(new Date().getTime() / 1000);
    const unitData = {
      codetext: data.codetext,
      codetype: "UNITS",
      codevalue: data.codevalue,
      codeorder: 0,
      expiredtimestamp: exp,
      language: data.uqc,
      uqc: data.uqc,
      is_active: Number(data.is_active),
      id: data?.id,
    };
    let res = await createUnit({
      createCompanyCodeTranslationArrayInput: [unitData],
    });
     
    if (res?.data?.[0]?.statuscode === "Success") {
      setNewUnit([]);
      if(setData){
      if(currentUnit && currentUnit==data?.id){
      setData((prev)=>({
        ...prev,
        unit:"",
        unite:""
      }))
    }
    }
      // showSuccessSnackbar(`Unit${DeleteArray.length != 1 ? 
        // "s" : ""} Deleted `);
        showSuccessSnackbar("Unit Deleted");
      setDeleteArray((prev) => [...prev, data.id]);
      let temp = [...unitArray];
      temp.splice(index, 1);
      setUnits([...temp]);

      // loadUserUnits();
      setLoading(false);
    } else {
      showErrorSnackbar(res?.error?.message);
      setLoading(false);
    }
  };

  const updateStatusUnit = async (data, Is_Active) => {
    try {
      // const response = await API.graphql(
      //   graphqlOperation(cancelCompanyCodeTranslation, {
      //     updateCompanyCodeTranslationInput: {
      //       ID: data.ID, // Ensure the ID is coming from the data object
      //       Is_Active: Is_Active == 1 ? 0 : 1,
      //     },
      //   })
      // );

      const unitData = {
        id: data.id,
        codetext: data.codetext,
        codetype: "UNITS",
        codevalue: data.codevalue,
        // EnteredTimeStamp: Math.floor(new Date().getTime()/ 1000),
        expiredtimestamp: 0,
        language: data.uqc,
        uqc: data.uqc,
        is_active: data.is_active == 1 ? 0 : 1,
      };
      let response = await createUnit({
        createCompanyCodeTranslationArrayInput: [unitData],
      });

      // if (listData) listData();
      // loadUserUnits();
      if (response?.data?.[0]?.statuscode === "Success") {
      showSuccessSnackbar(
        `Unit ${Is_Active == 1 ? "Deactivated" : "Activated"}`
      );
      if(setData && Is_Active == 1){
        if(currentUnit && currentUnit==data?.id){
        setData((prev)=>({
          ...prev,
          unit:"",
          unite:""
        }))
      }
      }
      return response;
    }else{
      setLoading(false)
      showErrorSnackbar(response?.error?.message)
    }
    } catch (error) {
      console.log(error);
      showWarningSnackbar("Something went wrong!");
      throw error; // Re-throw the error if the calling function needs to handle it
    }
  };

  let validate = () => {
    let isvalid = true;
    if (newUnits.length) {
      newUnits.forEach((elem, index) => {
        if (!formValidation(elem, elem)) {
          isvalid = false;
          return;
        }
      });
    }
    return isvalid;
  };

  const Save = () => {
    setLoading(true);
    let isvalid = true;
    if (newUnits.length) {
      newUnits.forEach((elem, index) => {
        if (!formValidation(elem, elem)) {
          isvalid = false;
          return;
        }
      });
      if (!isvalid) return setLoading(false);
      newUnits.map((elem, index) => {
        if (elem.unit.length <= 20) {
          // console.log(elem);
          addunit(elem);
        } else {
          showWarningSnackbar("Invalid Unit");
          setOpen(true);
          setLoading(false);
        }

        // if (index + 1 == newUnits.length) {
        //     showSuccessSnackbar(`Unit${newUnits.length != 1 ? 's' : ''} Created`)
        //     setnewUnits([])
        // }
      });
    }
    // if (DeleteArray.length)
    //   DeleteArray.map(async (elem, index) => {
    //     try {
    //       let res = await API.graphql(
    //         graphqlOperation(deleteCompanyCodeTranslation, { ID: elem })
    //       );
    //       console.log("res", res?.data?.deleteCompanyCodeTranslation);
    //       if (res?.data?.deleteCompanyCodeTranslation?.StatusCode === "Error") {
    //         showErrorSnackbar(
    //           "Unit cannot be deleted as its already used with an Item !"
    //         );
    //         setLoading(false);
    //       } else {
    //         console.log("DeletedArray", DeleteArray);
    //         if (index + 1 === DeleteArray.length) {
    //           setDeleteArray([]);
    //           showSuccessSnackbar(
    //             `Unit${DeleteArray.length != 1 ? "s" : ""} Deleted`
    //           );
    //           setLoading(false);
    //         }
    //       }
    //     } catch (error) {
    //       console.log(error);
    //       setLoading(false);
    //     }
    //   });
    // handleClose()
    if (DeleteArray?.length > 0) {
      setOpen(false);
      setnewUnits([]);
      setLoading(false);
    }
  };
  const divRef = useRef(null);
  const scrollToBottom = () => {
    // setTimeout(() => {
    //   if (divRef.current) {
    //     divRef.current.scrollTo({
    //       top: divRef.current.scrollHeight,
    //       behavior: "smooth",
    //     });
    //   }
    // }, 200);
    const section = document.getElementById("target-section");
    setTimeout(() => {
      const newU = document.getElementById("Unit");
      newU?.focus();
    }, 200);
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  useEffect(() => {
    const keyDownHandler = (event) => {
      const lastField = event?.target?.id === "uqc";
      if (event.key === "Enter" || event.key === "Tab") {
        if (lastField) {
          Save();
        }
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [newUnits]);

  const handleRowCheck = (ID) => {
    let temp = JSON.parse(JSON.stringify(Selected));
    if (temp.indexOf(ID) == -1) {
      setSelected((prev) => [...prev, ID]);
    } else {
      temp.splice(temp.indexOf(ID), 1);
      setSelected(temp);
    }
  };
  const deleteSelected = async () => {
    let responseSuccess = [];
    let responseFailed = [];

    let requests = [];
    for (let index = 0; index < Selected.length; index++) {
      let elem = Selected[index];
      let res = requests.push(
        API.graphql(
          graphqlOperation(deleteCompanyCodeTranslation, { ID: elem })
        )
      );
    }
    Promise.all(requests).then((response) => {
      console.log(response);
      response.map((res, index) => {
        let elem = Selected[index];
        if (res?.data?.deleteCompanyCodeTranslation?.StatusCode === "Error") {
          responseFailed.push({
            status: "failed",
            unit: unitArray.find((elems) => elems.ID == elem),
            StatusMessage:
              res?.data?.deleteCompanyCodeTranslation?.StatusMessage,
          });
        } else {
          console.log(res);
          responseSuccess.push({
            status: "success",
            unit: unitArray.find((elems) => elems.ID == elem),
          });
          // console.log('DeletedArray', DeleteArray);
          // showSuccessSnackbar(`Unit${DeleteArray.length != 1 ? 's' : ''} Deleted`)
          // setDeleteArray((prev) => [...prev, id])
          // let temp = [...unitArray]
          // temp.splice(index, 1)
          // setUnits([...temp])
          // setLoading(false)
        }
      });
      console.log(responseFailed, responseSuccess);
      if (responseFailed.length) {
        if (Selected.length != 1) {
          setWarningOpen({
            render: (
              <Box>
                <Typography color={"green"}>
                  {responseSuccess.length} out of {Selected.length} units was
                  successfully deleted !
                </Typography>
                <Typography color={"red"} sx={{ fontSize: "14px" }}>
                  Following units cannot be deleted !
                </Typography>
                <Box sx={{ background: "#ecece9", padding: "5px" }}>
                  {responseFailed.map((element) => {
                    return (
                      <Typography sx={{ fontSize: "10px" }}>
                        {element.unit.CodeText} :{" "}
                        {element.StatusMessage?.replace(
                          "Company Code Translation",
                          "This one"
                        )}
                      </Typography>
                    );
                  })}
                </Box>
              </Box>
            ),
            oncancel: () => setSelected([]),
            onContinue: () => setSelected([]),
          });
        } else {
          showWarningSnackbar("This unit cannot be deleted As Its Used !");
        }
      } else {
        showSuccessSnackbar("Selected Units Deleted !");
      }
      if (listData) listData();
      loadUserUnits();
    });
  };
 useSaveModalShortcut(Save)
  return (
    <div id={open ? "addUnit" : ""}>
      {WarningModal}
      <Modal
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        open={open}
        onClose={handleClose}
        sx={{ overflow: "", "-webkit-scrollbar": { width: 0 } }}
      >
        {/* <Fade in={open}> */}
        <Modal.Header>
          <Paper
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Configure / Add New Units for Stock Items
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Paper>
        </Modal.Header>
        <Modal.Body>
          <Paper
            sx={{
              overflowY: "scroll",
              margin: "4px",
              maxHeight: "75vh",
            }}
            className={"custom-scrollbar"}
            ref={divRef}
          >
            <Table
              sx={{
                ".MuiTableCell-root": {
                  backgroundColor: "transparent !important",
                },
              }}
              className="table-unitmodal"
            >
              <TableHead
                sx={{
                  backgroundColor: "#cedafd",
                  position: "sticky",
                  top: 0,
                  zIndex: 99,
                }}
              >
                <TableRow>
                  <TableCell>
                    {/* <Checkbox
                      onChange={() =>
                        Selected.length === unitArray.length
                          ? setSelected([])
                          : setSelected(() => unitArray.map((elem) => elem.ID))
                      }
                      checked={Selected.length === unitArray.length}
                    /> */}
                  </TableCell>
                  <TableCell>Sl</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell>UQC</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      Action{" "}
                      {Selected.length > 0 && (
                        <ThreeDot
                          onDelete={() =>
                            setWarningOpen({
                              render: (
                                <Box>
                                  <Typography>
                                    Are you sure you want to delete selected
                                    units(<b>{Selected.length}</b>) ?
                                  </Typography>
                                  <Typography
                                    component={"p"}
                                    sx={{ fontSize: "smaller" }}
                                  >
                                    Selected Units will be deleted immediately.
                                    You can't undo this action.
                                  </Typography>
                                </Box>
                              ),
                              onContinue: deleteSelected,
                            })
                          }
                        />
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {unitArray.map((elem, index) => {
                  return (
                    <TableRow
                      id={index == unitArray.length - 1 ? "target-section" : ""}
                      sx={{ maxHeight: "55px" }}
                    >
                      <TableCell>
                        {/* <Checkbox
                          onChange={() => handleRowCheck(elem.id)}
                          checked={Selected.indexOf(elem.id) >= 0}
                        ></Checkbox> */}
                      </TableCell>
                      <TableCell
                        sx={{ color: elem?.is_active == 0 ? "#979899" : "" }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{ color: elem?.is_active == 0 ? "#9e9e9e" : "" }}
                      >
                        {elem.codetext}
                      </TableCell>
                      <TableCell
                        sx={{ color: elem?.is_active == 0 ? "#9e9e9e" : "" }}
                      >
                        {elem?.uqc}
                      </TableCell>
                      <TableCell sx={{ whiteSpace: "nowrap" }}>
                        <Tooltip title={"Delete"}>
                          <IconButton
                            aria-label="delete"
                            sx={{
                              margin: "0px 2px",
                              padding: "5px",
                              backgroundColor: "#fbc7c7",
                            }}
                            onClick={() =>
                              setWarningOpen({
                                render: (
                                  <Box>
                                    <Typography>
                                      Are you sure you want to delete "
                                      <b>{elem.codetext}</b>" ?
                                    </Typography>
                                    <Typography
                                      component={"p"}
                                      sx={{ fontSize: "smaller" }}
                                    >
                                      This Unit will be deleted immediately. You
                                      can't undo this action.
                                    </Typography>
                                  </Box>
                                ),
                                onCancel: () => {},
                                onContinue: async () =>
                                  await deleteUnit(elem, index),
                              })
                            }
                            style={{
                              color: "black",
                              ":hover": { color: "red" },
                            }}
                          >
                            <DeleteIcon
                              sx={{
                                fontSize: "15px",
                                color: "#eb6a6a",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title={
                            elem?.is_active == 1
                              ? "Mark as In-Active"
                              : "Mark as Active"
                          }
                        >
                          <IconButton
                            aria-label="inactive"
                            sx={{
                              margin: "0px 2px",
                              padding: "5px",
                              backgroundColor:
                                elem?.is_active == 0 ? "#F6B26B" : "#FEF3C7",
                            }}
                            onClick={() =>
                              setWarningOpen({
                                render: (
                                  <Box>
                                    <Typography>
                                      Are you sure you want to{" "}
                                      {elem?.is_active == 1
                                        ? "Deactivate"
                                        : "Activate"}{" "}
                                      "<b>{elem.codetext}</b>" ?
                                    </Typography>
                                    <Typography
                                      component={"p"}
                                      sx={{ fontSize: "smaller" }}
                                    >
                                      This Unit will be{" "}
                                      {elem?.is_active == 1
                                        ? "Deactivated"
                                        : "Activated"}{" "}
                                      immediately. You can undo this action.
                                    </Typography>
                                  </Box>
                                ),
                                onCancel: () => {},
                                onContinue: async () =>
                                  await updateStatusUnit(elem, elem.is_active),
                              })
                            }
                            style={{
                              color: "green",
                              ":hover": { color: "red" },
                            }}
                          >
                            {/* <ShutterSpeed
                              sx={{
                                fontSize: "15px",
                                color: "#eb6a6a",
                              }}
                            /> */}
                            {elem?.is_active == 1 ? (
                              <DirectionsRun
                                sx={{
                                  fontSize: "15px",
                                  color: "#E29819",
                                }}
                              />
                            ) : (
                              <Accessibility
                                sx={{
                                  fontSize: "15px",
                                  color: "#ffff",
                                }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {newUnits.map((elem, index) => {
                  return (
                    <AddNewUnit
                      Save={Save}
                      data={elem}
                      index={index}
                      slno={unitArray.length + 1 + index}
                      deleteUnit={(index) => {
                        let temp = [...newUnits];
                        temp.splice(index, 1);
                        setnewUnits([...temp]);
                      }}
                      onChange={(value, indexx) => {
                        let temp = [...newUnits];
                        temp[indexx] = value;
                        setnewUnits([...temp]);
                      }}
                      uqcArray={uqcArray}
                    />
                  );
                })}

                {unitArray.length === 0 &&
                  newUnits.length === 0 &&
                  tableLoading === false && (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                        No Data found
                      </TableCell>
                    </TableRow>
                  )}
                <>
                  {tableLoading &&
                    Array.from({ length: 8 }).map((_, index) => (
                      <TableRow key={index}>
                        {" "}
                        <TableCell colSpan={5}>
                          <Skeleton animation="wave" />
                        </TableCell>{" "}
                      </TableRow>
                    ))}
                </>
                {/* <TableRow>
                  {" "}
                  <TableCell sx={{ height: "100px" }} colSpan={5}>
                    <Box></Box>
                  </TableCell>{" "}
                </TableRow> */}
              </TableBody>
            </Table>
          </Paper>
        </Modal.Body>

        <Modal.Footer>
          {newUnits.length == 0 && (
            <Paper
              sx={{
                display: "block",
                width: "100%",
                bottom: "56px",
                textAlign: "right",
                zIndex: 99,
                boxSizing: "border-box",
                paddingRight: "10px",
              }}
            >
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  if (validate()) {
                    setnewUnits((prev) => [
                      ...prev,
                      {
                        unit: "",
                        uqc: "",
                        errorStatus: {
                          unit: false,
                          uqc: false,
                        },
                        errorFields: {
                          unit: "",
                          uqc: "",
                        },
                      },
                    ]);
                    scrollToBottom();
                  }
                }}
                startIcon={<AddBox />}
                className="ledgerx-btn-active"
                sx={{
                  fontSize: "14px",
                  marginTop: "15px",
                }}
              >
                Add New
              </Button>
            </Paper>
          )}
          {newUnits.length == 1 && (
            <Paper
              sx={{
                // padding : "15px",
                // width:'100%',
                display: "flex",
                justifyContent: "space-between",
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                disabled={loading}
                onClick={() => setnewUnits([])}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              {/* <Button onClick={addunit} variant='contained' sx={{flex:1,margin:'10px', fontSize : "12px"}} >Add</Button> */}
              <LoadingButton
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                loading={loading}
                disableRipple={true}
                variant="contained"
                onClick={() => Save()}
              >
                Save
              </LoadingButton>
            </Paper>
          )}
        </Modal.Footer>
        {/* </Fade> */}
      </Modal>
    </div>
  );
};
export function useWarningModal() {
  const [open, setOpen] = React.useState(false);
  const [Content, setContent] = useState({
    render: "",
    onContinue: () => {},
    onCancel: () => {},
  });
  const [Loading, setLoading] = useState(false);
  const handleOpen = (content) => {
    setContent(content);
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    try {
      if (reason !== "backdropClick") {
        setOpen(false);
        setLoading(true);
        if (typeof Content?.onCancel == "function") Content?.onCancel();
        setOpen(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleContinue = async () => {
    try {
      setLoading(true);
      if (typeof Content?.onContinue == "function") await Content?.onContinue();
      setOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    WarningModal: (
      <React.Fragment>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Modal.Header>
            <Paper
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 10px",
                display: "flex",
                flexDirection: "row",
                minWidth: "350px",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Warning
                  <IconButton
                    onClick={handleClose}
                    disabled={Loading}
                    aria-label="delete"
                  >
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Paper>
          </Modal.Header>
          <Modal.Body>
            <Paper sx={{ ...style, margin: 2 }}>{Content.render}</Paper>
          </Modal.Body>
          <Modal.Footer>
            <Paper
              sx={{
                display: "flex",
                justifyContent: "end",
                padding: "5px",
                gap: 1,
              }}
            >
              <Button
                disabled={Loading}
                onClick={handleClose}
                variant="outlined"
              >
                Close
              </Button>
              {Loading ? (
                <LoadingButton
                  sx={{ width: "108px" }}
                  disabled={true}
                  variant="contained"
                >
                  <CircularProgress color="inherit" size={16} />
                </LoadingButton>
              ) : (
                <Button
                  disabled={Loading}
                  onClick={handleContinue}
                  variant="contained"
                >
                  Continue
                </Button>
              )}
            </Paper>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    ),
    handleOpen,
  };
}
const AddNewUnit = ({
  Save,
  onChange,
  uqcArray,
  deleteUnit,
  slno,
  index,
  data,
}) => {
  const [state, setState] = useState({
    unit: "",
    uqc: "",
    errorStatus: {
      unit: false,
      uqc: false,
    },
    errorFields: {
      unit: "",
      uqc: "",
    },
  });
  const inputRef = useRef(null);

  // Use useEffect to focus on the input element once the component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef?.current?.focus();
    }
  }, []);
  useEffect(() => {
    return () => {};
  }, [data]);

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "unit") {
      value = value
        ?.toLowerCase() // Convert to lower case
        .replace(/[^\w\s]/gi, "") // Remove special characters except for underscore
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    const id = e.target.id;
    // const unitregex = /^[a-zA-Z0-9]*$/;
    if (value === "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]:""
          //  id + " is required",
        },
      }));
    }
    // else if(!unitregex.test(value)){
    //     setState((prev) => ({
    //         ...prev,
    //         [name]: value,
    //         ['errorStatus']: {
    //             ...prev.errorStatus,
    //             [name]: true
    //         },
    //         ['errorFields']: {
    //             ...prev.errorFields,
    //             [name]: id + ' is Invalid'
    //         }
    //     }))
    // }
    else {
      const regex = /^.{0,20}$/;
      if (regex.test(value)) {
        setState((prev) => ({
          ...prev,
          [name]: value,
          ["errorStatus"]: {
            ...prev.errorStatus,
            [name]: "",
          },
          ["errorFields"]: {
            ...prev.errorFields,
            [name]: "",
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          ["errorStatus"]: {
            ...prev.errorStatus,
            [name]: true,
          },
          ["errorFields"]: {
            ...prev.errorFields,
            [name]: "Input exceeds 20 characters",
          },
        }));
      }
    }

    // setState( (prev) => ({
    //     ...prev,
    //     [name] : value,
    // }))
  };
  const handleAutocompleteChange = (event, newValue) => {
    // Create a synthetic event object to be compatible with your handleChange function
    const syntheticEvent = {
      target: {
        name: "uqc",
        value: newValue,
      },
    };
    handleChange(syntheticEvent);
  };
  useEffect(() => {
    onChange(state, index);

    return () => {};
  }, [state]);
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);

  return (
    <TableRow sx={{ maxHeight: "70px" }}>
      <TableCell>
        <Box sx={{ height: "60px" }} />
      </TableCell>
      <TableCell sx={{ alignContent: "flex-start" }}>
        <Box sx={{ mt: "10px" }}>{slno}</Box>
      </TableCell>
      <TableCell sx={{ alignContent: "flex-start" ,border:"none !important"}}>
        <Box
          sx={{
            mt: "10px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onKeyUp={() => {
            if (state.errorStatus.unit == true) {
              setTimeout(() => {
                setState((prev) => ({
                  ...prev,
                  ["errorStatus"]: {
                    ...prev.errorStatus,
                    ["unit"]: false,
                  },
                  ["errorFields"]: {
                    ...prev.errorFields,
                    ["unit"]: "",
                  },
                }));
              }, 500);
            }
          }}
          onKeyDown={(e) => {
            if (e.key == "Enter" && !autocompleteOpen) {
              Save();
            }
          }}
        >
          <InputField
            name="unit"
            id="unit"
            placeholder="Unit"
            size="small"
            ref={inputRef}
            fullWidth
            required={true}
            autoFocus={true}
            type="text"
            state={state}
            value={state.unit}
            onChange={(e) => handleChange(e)}
            onBlur={() => {
              setState((prev) => ({
                ...prev,
                unit: prev.unit?.replace(/\s+/g, " ")?.trim(),
                ["errorStatus"]: {
                  ...prev.errorStatus,
                  ["unit"]: false,
                },
                ["errorFields"]: {
                  ...prev.errorFields,
                  ["unit"]: "",
                },
              }));
            }}
          />
        </Box>
      </TableCell>
      <TableCell sx={{ minWidth: "80px", alignContent: "flex-start" ,border:"none !important"}}>
        {/* <TextField
          error={state.errorStatus.uqc}
          select
          name="uqc"
          id="uqc"
          variant="outlined"
          required={true}
          label="UQC"
          size="small"
          state={state}
          fullWidth
          value={state.uqc}
          onChange={(e) => {
            handleChange(e);
          }}
          sx={{
            ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
              fontSize: "14px",
            },
            label: {
              fontSize: "14px",
            },
            ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
              fontSize: "14px",
            },
            ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
              color: "input.font",
            },
            ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
              borderColor: "input.border",
            },
            ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
              color: "input.font",
            },
            ".css-wgai2y-MuiFormLabel-asterisk": {
              color: "danger.main",
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {uqcArray?.map((item, ind) => {
            return (
              <MenuItem key={item.option} value={`${item.option}`}>
                <ListItemText
                  sx={{ margin: "0px", textTransform: "capitalize" }}
                  primary={item.option}
                />
              </MenuItem>
            );
          })} */}
        {/* <MenuItem
    value={"addgstrate"}
    // onClick={() => setUnitModal(true)}
  >
    <SettingsIcon
      fontSize="small"
      sx={{ marginRight: "5px" }}
    />
    <ListItemText
      primary={"Configure / Add GST Rate"}
    />
  </MenuItem> */}
        {/* </TextField> */}
        <Autocomplete
          onOpen={() => setAutocompleteOpen(true)}
          onClose={() => setAutocompleteOpen(false)}
          openOnFocus
          disableClearable
          disablePortal
          options={uqcArray.map((item) => item.option)}
          value={state.uqc}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField
              onKeyDown={(e) => {
                if (e.key == "Enter" && !autocompleteOpen) {
                  Save();
                }
              }}
              {...params}
              value={state.uqc}
              error={state.errorStatus.uqc}
              name="uqc"
              id="uqc"
              variant="outlined"
              required={true}
              label="UQC"
              size="small"
              fullWidth
              InputLabelProps={
                {
                  // shrink: true,
                }
              }
              sx={{
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                  fontSize: "14px",
                },
                label: {
                  fontSize: "12px",
                },
                ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                  fontSize: "14px",
                },
                ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                  color: "input.font",
                },
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  borderColor: "input.border",
                },
                ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                  color: "input.font",
                },
                ".MuiFormLabel-asterisk": {
                  color: "danger.main",
                  fontSize: "20px",
                  fontWeight: "bold",
                },
              }}
            />
          )}
          sx={{
            mt: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      </TableCell>
      <TableCell
        sx={{
          alignContent: "flex-start",
          border:"none !important"
        }}
      >
        <IconButton
          aria-label="delete"
          sx={{
            margin: "10px 2px",
            padding: "5px",
            backgroundColor: "#fbc7c78c",
          }}
          onClick={() => deleteUnit(index)}
          style={{ color: "black", ":hover": { color: "red" } }}
        >
          <DeleteIcon
            sx={{
              fontSize: "15px",
              color: "#eb6a6a",
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default AddUnitsModal;
